function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.3037 13.0447C47.5096 13.0447 47.6765 12.8826 47.6765 12.6827C47.6765 12.4828 47.5096 12.3208 47.3037 12.3208H44.0994C43.8935 12.3208 43.7265 12.4828 43.7265 12.6827C43.7265 12.8826 43.8935 13.0447 44.0994 13.0447H47.3037Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M47.2197 13.1097H47.6269C47.8518 13.1097 47.8518 12.2559 47.6269 12.2559H46.9836C46.7587 12.2559 46.7587 13.1097 46.9836 13.1097H47.2197Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.63147 22.0088V24.9633H45.9918V22.0088H0.63147ZM18.0786 24.203C18.0786 24.2808 18.0127 24.3448 17.9327 24.3448H13.8662C13.7862 24.3448 13.7204 24.2808 13.7204 24.203V22.774C13.7204 22.6962 13.7862 22.6322 13.8662 22.6322H17.9327C18.0127 22.6322 18.0786 22.6962 18.0786 22.774V24.203ZM32.9029 24.203C32.9029 24.2808 32.837 24.3448 32.757 24.3448H28.6905C28.6105 24.3448 28.5446 24.2808 28.5446 24.203V22.774C28.5446 22.6962 28.6105 22.6322 28.6905 22.6322H32.757C32.837 22.6322 32.9029 22.6962 32.9029 22.774V24.203Z",
  fill: "#A0A1A7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.37278 1.24817C3.37278 1.04801 3.2061 0.885742 3.00048 0.885742C2.79486 0.885742 2.62817 1.04801 2.62817 1.24817V4.36324C2.62817 4.5634 2.79486 4.72567 3.00048 4.72567C3.2061 4.72567 3.37278 4.5634 3.37278 4.36324V1.24817Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.44071 1.32893V0.93302C3.44071 0.714384 2.56238 0.714384 2.56238 0.93302V1.5584C2.56238 1.77704 3.44071 1.77704 3.44071 1.5584V1.32893Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.48509 0.488776C5.48509 0.376185 5.3912 0.284912 5.27538 0.284912C5.15956 0.284912 5.06567 0.376185 5.06567 0.488776V4.52173C5.06567 4.63432 5.15956 4.72559 5.27538 4.72559C5.3912 4.72559 5.48509 4.63432 5.48509 4.52173V0.488776Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5216 0.534144V0.311568C5.5216 0.188462 5.02722 0.188462 5.02722 0.311568V0.663159C5.02722 0.786265 5.5216 0.786265 5.5216 0.663159V0.534144Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M9.20713 1.24817C9.20713 1.04801 9.04044 0.885742 8.83483 0.885742C8.62921 0.885742 8.46252 1.04801 8.46252 1.24817V4.36324C8.46252 4.5634 8.62921 4.72567 8.83483 4.72567C9.04044 4.72567 9.20713 4.5634 9.20713 4.36324V1.24817Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9.27396 1.32893V0.93302C9.27396 0.714384 8.39563 0.714384 8.39563 0.93302V1.5584C8.39563 1.77704 9.27396 1.77704 9.27396 1.5584V1.32893Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3183 0.488776C11.3183 0.376185 11.2244 0.284912 11.1086 0.284912C10.9928 0.284912 10.8989 0.376185 10.8989 0.488776V4.52173C10.8989 4.63432 10.9928 4.72559 11.1086 4.72559C11.2244 4.72559 11.3183 4.63432 11.3183 4.52173V0.488776Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3558 0.534144V0.311568C11.3558 0.188462 10.8615 0.188462 10.8615 0.311568V0.663159C10.8615 0.786265 11.3558 0.786265 11.3558 0.663159V0.534144Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0415 1.24817C15.0415 1.04801 14.8748 0.885742 14.6692 0.885742C14.4636 0.885742 14.2969 1.04801 14.2969 1.24817V4.36324C14.2969 4.5634 14.4636 4.72567 14.6692 4.72567C14.8748 4.72567 15.0415 4.5634 15.0415 4.36324V1.24817Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1083 1.32893V0.93302C15.1083 0.714384 14.23 0.714384 14.23 0.93302V1.5584C14.23 1.77704 15.1083 1.77704 15.1083 1.5584V1.32893Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1527 0.488776C17.1527 0.376185 17.0588 0.284912 16.943 0.284912C16.8272 0.284912 16.7333 0.376185 16.7333 0.488776V4.52173C16.7333 4.63432 16.8272 4.72559 16.943 4.72559C17.0588 4.72559 17.1527 4.63432 17.1527 4.52173V0.488776Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1902 0.534144V0.311568C17.1902 0.188462 16.6958 0.188462 16.6958 0.311568V0.663159C16.6958 0.786265 17.1902 0.786265 17.1902 0.663159V0.534144Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8746 1.24817C20.8746 1.04801 20.7079 0.885742 20.5023 0.885742C20.2967 0.885742 20.13 1.04801 20.13 1.24817V4.36324C20.13 4.5634 20.2967 4.72567 20.5023 4.72567C20.7079 4.72567 20.8746 4.5634 20.8746 4.36324V1.24817Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9425 1.32893V0.93302C20.9425 0.714384 20.0642 0.714384 20.0642 0.93302V1.5584C20.0642 1.77704 20.9425 1.77704 20.9425 1.5584V1.32893Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9869 0.488776C22.9869 0.376185 22.893 0.284912 22.7772 0.284912C22.6614 0.284912 22.5675 0.376185 22.5675 0.488776V4.52173C22.5675 4.63432 22.6614 4.72559 22.7772 4.72559C22.893 4.72559 22.9869 4.63432 22.9869 4.52173V0.488776Z",
  fill: "#BC8855",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0234 0.534144V0.311568C23.0234 0.188462 22.5291 0.188462 22.5291 0.311568V0.663159C22.5291 0.786265 23.0234 0.786265 23.0234 0.663159V0.534144Z",
  fill: "#AC6C32",
  stroke: "#AC6C32",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M46.1791 4.49219H0.442993V22.2195H46.1791V4.49219Z",
  fill: "#CCCECF",
  stroke: "#A4A9AC",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3332 4.49219H0.289062V5.11067H46.3332V4.49219Z",
  fill: "#CCCECF",
  stroke: "#A4A9AC",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7535 7.77186C38.0053 7.77186 38.2094 7.57344 38.2094 7.32868C38.2094 7.08392 38.0053 6.8855 37.7535 6.8855C37.5017 6.8855 37.2976 7.08392 37.2976 7.32868C37.2976 7.57344 37.5017 7.77186 37.7535 7.77186Z",
  fill: "#606770"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7535 16.9379C38.0053 16.9379 38.2094 16.7395 38.2094 16.4947C38.2094 16.2499 38.0053 16.0515 37.7535 16.0515C37.5017 16.0515 37.2976 16.2499 37.2976 16.4947C37.2976 16.7395 37.5017 16.9379 37.7535 16.9379Z",
  fill: "#606770"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8061 7.25879H37.7008C37.604 7.25879 37.5255 7.33507 37.5255 7.42917V16.3952C37.5255 16.4893 37.604 16.5656 37.7008 16.5656H37.8061C37.9029 16.5656 37.9814 16.4893 37.9814 16.3952V7.42917C37.9814 7.33507 37.9029 7.25879 37.8061 7.25879Z",
  fill: "#B8BBBD",
  stroke: "#A4A9AC",
  strokeWidth: 0.05,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M34.0284 6.8855H28.1162C27.8644 6.8855 27.6603 7.08392 27.6603 7.32868V13.9557C27.6603 14.2005 27.8644 14.3989 28.1162 14.3989H34.0284C34.2802 14.3989 34.4843 14.2005 34.4843 13.9557V7.32868C34.4843 7.08392 34.2802 6.8855 34.0284 6.8855Z",
  fill: "#E8E8E8"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6566 7.43115H28.4889C28.363 7.43115 28.261 7.53036 28.261 7.65274V13.6318C28.261 13.7541 28.363 13.8533 28.4889 13.8533H33.6566C33.7825 13.8533 33.8845 13.7541 33.8845 13.6318V7.65274C33.8845 7.53036 33.7825 7.43115 33.6566 7.43115Z",
  fill: "#A4A9AC"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4554 11.199H29.1484C29.0779 11.199 29.0208 11.2545 29.0208 11.3231V11.6215C29.0208 11.69 29.0779 11.7456 29.1484 11.7456H29.4554C29.5259 11.7456 29.583 11.69 29.583 11.6215V11.3231C29.583 11.2545 29.5259 11.199 29.4554 11.199Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4554 12.0076H29.1484C29.0779 12.0076 29.0208 12.0631 29.0208 12.1317V12.4301C29.0208 12.4986 29.0779 12.5542 29.1484 12.5542H29.4554C29.5259 12.5542 29.583 12.4986 29.583 12.4301V12.1317C29.583 12.0631 29.5259 12.0076 29.4554 12.0076Z",
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M32.996 11.199H32.689C32.6185 11.199 32.5614 11.2545 32.5614 11.3231V11.6215C32.5614 11.69 32.6185 11.7456 32.689 11.7456H32.996C33.0665 11.7456 33.1237 11.69 33.1237 11.6215V11.3231C33.1237 11.2545 33.0665 11.199 32.996 11.199Z",
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M32.996 12.0076H32.689C32.6185 12.0076 32.5614 12.0631 32.5614 12.1317V12.4301C32.5614 12.4986 32.6185 12.5542 32.689 12.5542H32.996C33.0665 12.5542 33.1237 12.4986 33.1237 12.4301V12.1317C33.1237 12.0631 33.0665 12.0076 32.996 12.0076Z",
  fill: "white"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5458 7.10303H10.1523V8.8275H16.5458V7.10303Z",
  fill: "#023171"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4683 8.36959H12.9718V8.23566H12.6182V8.02884H12.9414V7.8949H12.6182V7.69497H12.9718V7.56104H12.4683V8.36959Z",
  fill: "white"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6787 8.36959H15.1832V8.23566H14.8286V8.02884H15.1518V7.8949H14.8286V7.69497H15.1832V7.56104H14.6787V8.36959Z",
  fill: "white"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M13.381 7.56104H13.2321V8.36959H13.7204V8.23566H13.381V7.56104Z",
  fill: "white"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1054 7.56104H13.9554V8.36959H14.4448V8.23566H14.1054V7.56104Z",
  fill: "white"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9932 8.05641L10.7703 7.56104H10.6265V8.36959H10.7703V7.88702L10.9294 8.23073H11.057L11.2151 7.88702V8.36959H11.3599V7.56104H11.2151L10.9932 8.05641Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9086 8.04459C15.9714 8.01898 16.016 7.95891 16.016 7.888V7.73141C16.016 7.63785 15.9379 7.56201 15.8417 7.56201H15.4446V8.36959H15.5945V8.05739H15.7515L15.9086 8.36959H16.0737L15.9096 8.04459H15.9086ZM15.866 7.85648C15.866 7.89391 15.8346 7.92444 15.7961 7.92444H15.5935V7.69497H15.7961C15.8346 7.69497 15.866 7.7255 15.866 7.76292V7.85648Z",
  fill: "white"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0407 8.15687C12.0407 8.2002 12.0042 8.23566 11.9596 8.23566H11.8675C11.8229 8.23566 11.7864 8.2002 11.7864 8.15687V7.56104H11.6365V8.18937C11.6365 8.28884 11.7195 8.36861 11.8209 8.36861H12.0042C12.1065 8.36861 12.1896 8.28785 12.1896 8.18838V7.56104H12.0397V8.15687H12.0407Z",
  fill: "white"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M7.92964 13.9005C8.23009 13.9005 8.47366 13.6567 8.47366 13.3559C8.47366 13.0551 8.23009 12.8113 7.92964 12.8113C7.62919 12.8113 7.38562 13.0551 7.38562 13.3559C7.38562 13.6567 7.62919 13.9005 7.92964 13.9005Z",
  fill: "#606770"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7685 13.9005C19.069 13.9005 19.3125 13.6567 19.3125 13.3559C19.3125 13.0551 19.069 12.8113 18.7685 12.8113C18.4681 12.8113 18.2245 13.0551 18.2245 13.3559C18.2245 13.6567 18.4681 13.9005 18.7685 13.9005Z",
  fill: "#606770"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8856 8.37842H29.2386C29.1127 8.37842 29.0106 8.47763 29.0106 8.60001V10.3727C29.0106 10.4951 29.1127 10.5943 29.2386 10.5943H32.8856C33.0115 10.5943 33.1136 10.4951 33.1136 10.3727V8.60001C33.1136 8.47763 33.0115 8.37842 32.8856 8.37842Z",
  fill: "white"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M33.1136 8.59705C33.1125 8.47592 33.0102 8.37842 32.8856 8.37842H29.2386C29.1129 8.37842 29.0106 8.47789 29.0106 8.60001V8.90236H33.1136V8.59705Z",
  fill: "#5A7BBC"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8856 8.57539C32.8988 8.57539 32.9109 8.58721 32.9109 8.60001V10.3727C32.9109 10.3855 32.8988 10.3974 32.8856 10.3974H29.2386C29.2254 10.3974 29.2132 10.3855 29.2132 10.3727V8.60001C29.2132 8.58721 29.2254 8.57539 29.2386 8.57539H32.8856ZM32.8856 8.37842H29.2386C29.1129 8.37842 29.0106 8.47789 29.0106 8.60001V10.3727C29.0106 10.4949 29.1129 10.5943 29.2386 10.5943H32.8856C33.0112 10.5943 33.1136 10.4949 33.1136 10.3727V8.60001C33.1136 8.47789 33.0112 8.37842 32.8856 8.37842Z",
  fill: "#7D8189"
});

var SvgLsChiller = function SvgLsChiller(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 25,
    viewBox: "0 0 48 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLsChiller, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LS_Chiller.efc68ac9.svg";
export { ForwardRef as ReactComponent };